import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "../../../provider/CommonContext";
import { Col, Container, Row } from 'react-bootstrap';
import './IPONews.css';
import Pagination from '../../CommonUI/Pagination/Pagination';
import { format, parseISO } from 'date-fns';
import { Modal } from "react-bootstrap";
import renderHTML from 'react-render-html';
import MarketIPO from "../MarketIPO";
import { Vortex } from 'react-loader-spinner';
let companyInformation;

function IPONews() {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [data, setData] = useState([]);
    const [filteredNewsData, setFilteredNewsData] = useState([]);
    const [companyInfo, setCompanyInfo] = useState([]);

    const [dataGroup, setDataGroup] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [loadingshow, setloadingshow] = useState(false);
    const { BaseURL } = useContext(URLstateContext);
    let getData, getDataGroup, eleBtn, eleBtnLoose, eleLi;
    let PageSize = 8;


    useEffect(() => {
        setloadingshow(true);
        window.scrollTo(0, 0)
        const getUrl = BaseURL + "News";
        fetch(`${getUrl}/28/117/-/100`)
            .then((response) => response.json())
            .then((data) => {
                getData = data.data;
                setData(getData);
                companyInformation = data.data;
                //console.log(data.data)
                setCompanyInfo(companyInformation);
                console.log("data", companyInformation);
                // console.log(getData, "getData")
                setloadingshow(false);
            })
            .catch((error) => {
            });


    }, []);



    const currentTableData = useMemo(() => {
        if (data != null && data != []) {
            const firstPageIndex = (currentPage - 1) * PageSize;
            const lastPageIndex = firstPageIndex + PageSize;
            if (data != null && data != []) {
                if (data.length > 0) {
                    return data.slice(firstPageIndex, lastPageIndex);
                }
            }
        }
    }, [currentPage, data]);

    const handleClosePopup = () => {
        setShow(false);
    }
    const newsModal = (e) => {
        const fetchId = e.currentTarget.getAttribute('data-id');
        let filteredCompanyInformation = companyInfo.filter(oneData => { return parseInt(oneData['Sno']) === parseInt(fetchId) })
        console.log(filteredCompanyInformation)

        setFilteredNewsData(filteredCompanyInformation)
        handleShow();
    }

    return (
        <>
            <div class="col-12 p-0 breadcrumIPo ">
                <ul>
                    <li><a href="/">Home</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li><a href="/market/ipo">IPO</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li>IPO News</li>
                </ul>
            </div>
            <Container>
                <Row>
                    <Col sm={12}>
                        <section className='IPONews-loser-sc'>
                            <div className='IPONews-header'>
                                <h2><span>IPO News</span></h2>
                            </div>
                            <MarketIPO optionValue="IPO News" />
                            {/* <hr className="Mosthr"></hr> */}
                            <div className='IPONews-table table-responsive'>
                                <table className='table'>
                                    <thead>
                                        <tr>
                                            <th className='text-left' >Date</th>
                                            <th className='text-left' >Time</th>
                                            <th className='text-left'>Headline</th>
                                        </tr>

                                    </thead>
                                    <tbody>
                                        {currentTableData && currentTableData.map(

                                            ({ Date, Time, Heading, Sno }) => (
                                                <tr>
                                                    <td className="text-left"> {(Date != null) ? Date.split('T')[0] : 0}</td>

                                                    <td className="text-left"> {Time}</td>
                                                    <a data-id={Sno} onClick={newsModal}>
                                                        <td className="newhead text-left">{Heading} </td>
                                                    </a>
                                                </tr>
                                            ))}


                                        {filteredNewsData &&
                                            filteredNewsData.map(({ Heading, Arttext }) => (
                                                <Modal show={show} className="modal company-snap-modal">

                                                    <Modal.Body id="modal_info">
                                                        <div className="titleCompany">{Heading}</div>
                                                        <div className="btnDiv">
                                                            <div className="btncl" onClick={handleClosePopup} > X </div>
                                                        </div>
                                                        <div className="infoCompany">{renderHTML(Arttext)}</div>
                                                    </Modal.Body>

                                                </Modal>
                                            ))}

                                    </tbody>
                                </table>

                                {loadingshow ? <div className="textcentervertex">
                                    <Vortex
                                        visible={true}
                                        height="80"
                                        width="80"
                                        ariaLabel="vortex-loading"
                                        wrapperStyle={{}}
                                        wrapperClass="vortex-wrapper"
                                        colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                    />
                                    <div className="model_popup">Please Wait...</div>
                                </div> : ""
                                }


                            </div>
                            {(data != null && data != []) ?
                                <Pagination
                                    className="pagination-bar_peer"
                                    currentPage={currentPage}
                                    totalCount={(data.length != null) ? data.length : 0}
                                    pageSize={PageSize}
                                    onPageChange={page => setCurrentPage(page)}
                                /> : <p className="errorPeer"> No Data Found !!! </p>}

                        </section>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default IPONews;